export const PORT_FACILITIES = [
    { name: 'breakBulk', label: 'Break bulk' },
    { name: 'dryDock', label: 'Dry Dock' },
    { name: 'roro', label: 'Ro-Ro' },
    { name: 'container', label: 'Container' },
    { name: 'lpg', label: 'LPG' },
    { name: 'lng', label: 'LNG' },
    { name: 'liquid', label: 'Liquid' },
    { name: 'multipurpose', label: 'Multipurpose' },
    { name: 'passenger', label: 'Passenger' },
    { name: 'dryBulk', label: 'Dry Bulk' },
    { name: 'bunkering', label: 'Bunkering' },
    { name: 'steel', label: 'Steel' },
    { name: 'shipyard', label: 'Shipyard' },
    { name: 'reefer', label: 'Reefer' },
];

export const PORT_RESTRICTIONS = [
    { name: 'maxDraught', label: 'Max Draft, m' },
    { name: 'maxBeam', label: 'Max Beam, m' },
    { name: 'maxLOA', label: 'Max LOA, m' },
    { name: 'maxDWT', label: 'Max DWT, mt' },
    { name: 'channelDepth', label: 'Channel Depth, m' },
    { name: 'anchorageDepth', label: 'Anchorage Depth, m' },
    { name: 'meanTide', label: 'Mean Tide, m' },
];

export const PORT_WAREHOUSE_TYPES = [
    { name: 'timber', label: 'Timber' },
    { name: 'grain', label: 'Grain' },
    { name: 'lpg', label: 'LPG' },
    { name: 'chemicals', label: 'Chemicals' },
    { name: 'dryBulk', label: 'Dry bulk (ore, coal, etc)' },
    { name: 'liquid', label: 'Liquid' },
    { name: 'general', label: 'General cargo' },
    { name: 'reefer', label: 'Reefer cargo' },
];



// WEBPACK FOOTER //
// ./app/constants/ports.js